import React from 'react'

const ConversationSkeltonBox = () => {
    return (
        <div className='animate-pulse w-full py-3 px-4 cursor-pointer hover:bg-overlay-hover border-t-[1px] border-t-edge-faint'>
            <div className='w-full flex items-center justify-start'>
                <div className='bg-overlay-mid border border-edge-faint min-h-[50px] min-w-[50px] h-[50px] w-[50px] rounded-full flex items-center justify-center'>
                </div>
                <div className='w-full max-w-[100%] ml-3'>
                    <div className='bg-overlay-mid border border-edge-faint w-[100%] h-[18px] rounded-sm'></div>
                    <div className='bg-overlay-mid border border-edge-faint w-[100%] h-[10px] rounded-sm mt-[8px]'></div>
                </div>
            </div>
        </div>
    )
}

export default ConversationSkeltonBox
